import { OrderNotRefundList } from 'pages/financial/order_not_refunds';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'order_not_refunds',
  label: 'Reembolsos com Erro',
  list: OrderNotRefundList,
  actions: ['list'],
  parentName: 'financial',
  route: 'order_not_refunds'
};

export default generateResources(resource);
